/* istanbul ignore file */
/**
 * Copyright Warner Bros. Entertainment, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property
 * of Warner Bros. Entertainment, Inc. and its suppliers, if any.
 * The intellectual and technical concepts contained herein are
 * proprietary to Warner Bros. Entertainment, Inc. and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in process,
 * and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is
 * unlawful and strictly forbidden unless prior written permission is
 * obtained from Warner Bros. Entertainment, Inc.
 */

const CONSTANTS = {
    CONTENT_TYPES: {
        FULL_EPISODE: {id: 101, name: 'Full Episode'},
        FULL_PROGRAM: {id: 102, name: 'Full Program'},
        FEATURE: {id: 103, name: 'Feature'},
        SERIES_LAUNCH_PROMO: {id: 121, name: 'Series Launch Promo'},
        SEASON_LAUNCH_PROMO: {id: 122, name: 'Season Launch Promo'},
        MID_SEASON_PROMO: {id: 123, name: 'Mid-Season Promo'},
        EPISODIC_PROMO: {id: 124, name: 'Episodic Promo'},
        GENERIC_PROMO: {id: 125, name: 'Generic Promo'},
        TEASER: {id: 126, name: 'Teaser'},
        TRAILER: {id: 127, name: 'Trailer'},
        NEXT_ON: {id: 128, name: 'Next On'},
        RECAP: {id: 129, name: 'Recap'},
        TV_SPOT: {id: 130, name: 'TV Spot'},
        SNEAK_PEEK: {id: 131, name: 'Sneak Peek'},
        GREEN_SCREEN: {id: 141, name: 'Green Screen'},
        CLIP: {id: 142, name: 'Clip'},
        TAGS: {id: 143, name: 'Tags'},
        B_ROLL: {id: 144, name: 'B-Roll'},
        GRAPHIC: {id: 145, name: 'Graphic'},
        ELEMENT: {id: 146, name: 'Element'},
        SOURCE_MATERIALS: {id: 147, name: 'Source Materials'},
        INTERSTITIAL: {id: 148, name: 'Interstitial'},
        CLIP_REEL: {id: 149, name: 'Clip Reel'},
        VAM: {id: 150, name: 'VAM'},
        TEXTLESS_MATERIALS: {id: 151, name: 'Textless Materials'},
        MUSIC: {id: 152, name: 'Music'},
        EPK: {id: 161, name: 'EPK'},
        FEATURETTE: {id: 162, name: 'Featurette'},
        INTERVIEW: {id: 163, name: 'Interview'},
        PROMOTIONAL_SPECIAL: {id: 164, name: 'Promotional Special'},
        BTS_FINISHED: {id: 165, name: 'BTS - Finished'},
        PANEL: {id: 167, name: 'Panel'},
        EVENT_FOOTAGE: {id: 168, name: 'Event Footage'},
        OPEN_ENDS: {id: 169, name: 'Open Ends'},
        WEBISODE: {id: 170, name: 'Webisode'},
        SALES_PRESENTATION: {id: 181, name: 'Sales Presentation'},
        SIZZLE_REEL: {id: 182, name: 'Sizzle Reel'},
        BRAND_EXTENSION: {id: 183, name: 'Brand Extension'},
        INTEGREATION_CLIP: {id: 184, name: 'Integration Clip'},
        SALES_KIT: {id: 185, name: 'Sales Kit'},
        MARKETING_KIT: {id: 186, name: 'Marketing Kit'},
        CLIENT_PRODUCED_SAMPLES: {id: 201, name: 'Client Produced Samples'},
        US_NETWORK_PRMOS: {id: 202, name: 'US Network Promos'}
    },

    toArray: function(constant) {
        return Object.keys(this[constant])
            .map(k => this[constant][k])
            .sort((a, b) => a.name.localeCompare(b.name));
    }
};

CONSTANTS.CONTENT_TYPE_MAP = Object.keys(CONSTANTS.CONTENT_TYPES).reduce((r, sctName) => {
    let type = CONSTANTS.CONTENT_TYPES[sctName];
    r[type.id.toString()] = type;
    return r;
}, {});

export {
    CONSTANTS as VIDEO_CT_TYPES
};
